import { Controller } from "@hotwired/stimulus"

// // INTENT: A header checkbox that ticks or clears every row's checkbox, and buttons that act on the ticked rows, as on
// // each card of a classroom's Licenses tab.
// // EXPECTED OUTCOME: Ticking "all" ticks every item and clearing it clears them. Ticking items by hand leaves "all"
// // ticked only when every item is, and half ticked (indeterminate) when some are. Actions are enabled only while at
// // least one item is ticked.
// // CAVEAT/TRAP: Actions are rendered enabled and disabled here on connect, so without JS they still submit and the
// // server answers when nothing is ticked.
export default class extends Controller {
  static targets = ["all", "item", "action"]

  connect() {
    this.sync()
  }

  toggle() {
    this.itemTargets.forEach(item => { item.checked = this.allTarget.checked })
    this.sync()
  }

  sync() {
    const ticked = this.itemTargets.filter(item => item.checked)

    if (this.hasAllTarget) {
      this.allTarget.checked = ticked.length > 0 && ticked.length === this.itemTargets.length
      this.allTarget.indeterminate = ticked.length > 0 && ticked.length < this.itemTargets.length
    }

    this.actionTargets.forEach(action => { action.disabled = ticked.length === 0 })
  }
}
